<template>
  <div class="add-black-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="120px">
        <el-form-item label="输入ip:" prop="ip">
          <el-input type="text" :rows="3" placeholder="请输入ip" v-model="params.ip" size="small"></el-input>
        </el-form-item>
        <el-form-item label="输入备注:" prop="remark">
          <el-input type="text" :rows="3" placeholder="请输入备注" v-model="params.remark" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      // 请求参数
      params: {
        ip: '',
        remark: '',
        id: ''
      },
      // 表单验证规则
      rules: {
        ip: [
          { required: true, message: '请输入ip', trigger: 'blur' }
        ],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '新增') {
            this.addBlack()
          } else {
            this.updBlack()
          }
        } else {
          return false
        }
      })
    },
    addCity() {
      return
    },
    // 新增标签
    addBlack() {
      API.addIpConfig(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$emit('handlerAddIpConfig')
        } else {
          this.$message.error('添加失败')
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose()
        this.flag = false
      })
    },

    // 编辑标签
    updBlack() {
      API.updateIpConfig(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
          this.$emit('handlerAddIpConfig')
        } else {
          this.$message.error('编辑失败')
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose()
        this.flag = false
      })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.params = {
        ip: '',
        remark: ''
      }
      this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, row) {
      this.dialogVisible = true
      if (type === 'add') {
        this.title = '新增'
      } else {
        this.title = '编辑'
        this.params.ip = row.ip
        this.params.remark = row.remark
        this.params.id = row.id
      }
    }
  }

}
</script>

<style lang="scss" >

</style>
